export enum Provider {
  Discord = 'discord',
  Google = 'google',
  Twitch = 'twitch',
  Facebook = 'facebook',
  Steam = 'steam',
  Faceit = 'faceit',
  Riot = 'riot',
}
